import React from 'react'
import { ShieldCheck, Lock } from "lucide-react";

function datasecure() {
    return (
        <div>
            <div className="mt-8 rounded-2xl bg-gradient-to-r from-[#EAF3FF] to-[#DDEBFF] border border-blue-100 shadow-sm p-4 md:p-6">
                <div className="flex flex-col md:flex-row items-center justify-between gap-6">

                    {/* Left Section */}
                    <div className="flex items-center gap-4">
                        <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-white/60 flex items-center justify-center shadow-sm">
                            <ShieldCheck
                                className="text-[#2563EB]"
                                size={42}
                                strokeWidth={2.2}
                            />
                        </div>

                        <div>
                            <h2 className="text-lg md:text-2xl font-bold text-[#1E2B5C]">
                                Your Data is 100% Secure with KuberMax
                            </h2>

                            <p className="mt-2 text-sm md:text-base text-gray-600">
                                We use advanced encryption and security to protect your
                                personal information.
                            </p>
                        </div>
                    </div>

                    {/* Right Section */}


                </div>
            </div>
        </div>
    )
}

export default datasecure